import analytics from '../../../analytics/Analytics';

angular.module('gallery').factory('galleryAnalytics', ['$rootScope', function($rootScope) {

    $rootScope.$on('updateMetaInfo', function(event, meta) {
        if (!meta.isFirstLoad) {
            sendGallerySlideViewCall(meta);
            sendParselyTracking();
        }
    });

    function getAttributeValue(attr) {
        return document.querySelector('[fs-prop="analytics"]').getAttribute(attr) || 'not specified';
    }

    function sendGallerySlideViewCall(meta) {
        var utagData = {
            page_type: 'gallery',
            page_attribute: 'gallery_slide_list',
            gallery_name: meta.headline,
            category: getAttributeValue('category'),
            slide_num: meta.slideNumber + 1,
            testScorestripPosition: 'gallery:modern',
            author: getAttributeValue('author'),
            story_title: getAttributeValue('story-title')
        };
        analytics.utagView(utagData);
    }

    function sendParselyTracking() {
        if (typeof PARSELY !== 'undefined' && typeof PARSELY.beacon === 'object' && typeof PARSELY.beacon.trackPageView === 'function') {
            PARSELY.beacon.trackPageView({
                url: location.href, // URL to be tracked
                urlref: location.href,
                js: 1 // flag indicating that this is a dynamic event, keep it "1"
            });
        }
    }
    return {};
}]);


// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/analytics/analyticsService.js